import * as React from "react"
export const CompactView = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
    <path
      fill={props?.color ??"#98a0ac"}
      d="M0 5.778h16v4.444H0Zm16-1.333v-2A2.447 2.447 0 0 0 13.556 0H2.444A2.447 2.447 0 0 0 0 2.444v2ZM0 11.556v2A2.447 2.447 0 0 0 2.444 16h11.112A2.447 2.447 0 0 0 16 13.556v-2Z"
    />
  </svg>
)
